/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Share_SelectedInputs */



/**
* | output |
* | --- |
* | "No share selected" |
*
* @param {Team_Share_No_Share_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_share_selected = /** @type {((inputs?: Team_Share_No_Share_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Share_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun partage sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Aktie ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna condivisione selezionata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Акции не выбраны")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha seleccionado ninguna acción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何股份")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有が選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई शेयर चयनित नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma ação selecionada")
	return /** @type {LocalizedString} */ ("No share selected")
});